module.exports = __webpack_public_path__ + "static/media/andjce-bourses-au-mérite-règlement.7f4429e4.pdf";